import React from 'react';


const ToggleSlider = ({ name, checked, onChange }) => {
    const handleToggle = (e) => {
        if (onChange) {
            onChange(e);
        }
    };

    return (
        <label className="toggle-slider">
            <input
                type="checkbox"
                name={name}
                checked={checked}
                onChange={handleToggle}
            />
            <span className="slider"></span>
        </label>
    );
};

export default ToggleSlider;